const env = process.env.NODE_ENV;

const PROD_API = "https://api.givelycf.com";
const PROD_UC = "https://uc.givelycf.com";
const PROD_WEBSITE = "https://www.givelycf.com";

const STAG_API = "https://test.api.givelycf.com";
const STAG_UC = "https://test.uc.givelycf.com";
const STAG_WEBSITE = "https://test.givelycf.com";

const DEV_API = "http://localhost:6601";
const DEV_UC = "http://localhost:6602";
const DEV_WEBSITE = "http://localhost:3000";

let apiBaseUrl = process.env.VUE_APP_API_BASE_URL || PROD_API;
let ucBaseUrl = process.env.VUE_APP_UC_BASE_URL || PROD_UC;
let websiteBaseUrl = process.env.VUE_APP_WEBSITE_BASE_URL || PROD_WEBSITE;

if (env === "development") {
  apiBaseUrl = process.env.VUE_APP_API_BASE_URL || DEV_API;
  ucBaseUrl = process.env.VUE_APP_UC_BASE_URL || DEV_UC;
  websiteBaseUrl = process.env.VUE_APP_WEBSITE_BASE_URL || DEV_WEBSITE;
} else if (env !== "production") {
  apiBaseUrl = process.env.VUE_APP_API_BASE_URL || STAG_API;
  ucBaseUrl = process.env.VUE_APP_UC_BASE_URL || STAG_UC;
  websiteBaseUrl = process.env.VUE_APP_WEBSITE_BASE_URL || STAG_WEBSITE;
}

export default {
  // Keep `main` as the crowdfunding/backend API for existing modules.
  main: apiBaseUrl,
  api: apiBaseUrl,
  uc: ucBaseUrl,
  website: websiteBaseUrl,
  envName: env,
  dev: DEV_UC,
  devCs: DEV_API,
  local: env == 'production' ? PROD_API : (env !== 'staging' ? STAG_API : DEV_API)
};
